import React from "react";
import { CustomModal } from "../CustomModal";
import { NotificationLists } from "./NotificationLists";

interface Props {
  open: boolean;
  onClose: () => unknown;
  wrapperStyle?: object;
}
export const NotificationModal = ({
  open,
  onClose,
  wrapperStyle = {},
}: Props) => {
  return (
    <CustomModal open={open} onClose={onClose} wrapperStyle={wrapperStyle}>
      <NotificationLists />
    </CustomModal>
  );
};
